// 🔒
import { useEffect, useMemo, useState } from "react";
import { testimonials } from "../data/testimonials";

const AUTOPLAY_DELAY = 7000;

export default function TestimonialsSection() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [autoplayEnabled, setAutoplayEnabled] = useState(true);

  const total = testimonials.length;

  const goToSlide = (index) => {
    setAutoplayEnabled(false);
    setActiveIndex(index);
  };

  const nextSlide = () => {
    setAutoplayEnabled(false);
    setActiveIndex((prev) => (prev + 1) % total);
  };

  const prevSlide = () => {
    setAutoplayEnabled(false);
    setActiveIndex((prev) => (prev - 1 + total) % total);
  };

  useEffect(() => {
    if (!autoplayEnabled || total <= 1) return;

    const timer = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % total);
    }, AUTOPLAY_DELAY);

    return () => clearInterval(timer);
  }, [autoplayEnabled, total]);

  const activeTestimonial = useMemo(
    () => testimonials[activeIndex],
    [activeIndex]
  );

  return (
    <section className="section testimonials" id="testimonials">
      <div className="container">
        <div className="section-heading testimonials__heading">
          <p className="eyebrow">TESTIMONIALS</p>
          <h2>What members are saying</h2>
          <p className="section-copy">
            Feedback from people training with EleFit.
          </p>
        </div>

        <div
          className="testimonials__wrap"
          onMouseEnter={() => setAutoplayEnabled(false)}
        >
          <article className="testimonial-card">
            <div className="testimonial-card__top">
              <p className="testimonial-kicker">Member review</p>

              <div
                className="testimonial-stars"
                aria-label={`${activeTestimonial.stars || 5} star rating`}
              >
                {Array.from({ length: activeTestimonial.stars || 5 }).map(
                  (_, index) => (
                    <span key={index} className="testimonial-star">
                      ★
                    </span>
                  )
                )}
              </div>
            </div>

            <div className="testimonial-textWrap">
              <p className="testimonial-text">“{activeTestimonial.text}”</p>
            </div>

            <div className="testimonial-footer">
              <p className="testimonial-name">{activeTestimonial.name}</p>
            </div>
          </article>
        </div>

        <div className="testimonial-controls">
          <button
            className="testimonial-nav testimonial-nav--left"
            onClick={prevSlide}
            aria-label="Previous testimonial"
          >
            ‹
          </button>

          <div className="testimonial-dots">
            {testimonials.map((item, index) => (
              <button
                key={item.id}
                className={`testimonial-dot ${
                  index === activeIndex ? "testimonial-dot--active" : ""
                }`}
                onClick={() => goToSlide(index)}
                aria-label={`Go to testimonial ${index + 1}`}
              />
            ))}
          </div>

          <button
            className="testimonial-nav testimonial-nav--right"
            onClick={nextSlide}
            aria-label="Next testimonial"
          >
            ›
          </button>
        </div>
      </div>
    </section>
  );
}
// 🔒